import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/cta-section/dashed-line-left.svg")